import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SponsorsService } from 'src/app/services/sponsors.service';
import { environment } from 'src/environments/environment';
import { CategoryService } from '../../../services/category.service';
import { ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class EditSponsorsComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string; 
  statuses: any = [];
  sponsorsForm: FormGroup;
  sponsorsStatus: boolean = true;
  notproduct: boolean = false;
  showUploadedpic: boolean = false;
  uploadedFiles: any[] = [];  
  sponsorsImages: { file: string }[] = [];
  submitted: boolean = false;
  catId: any;
  public sponsorsImage: any;
  public sponsorsImageUpload: any;
  previousSponsorsImageExists: boolean;
  minYear = environment.minYear;
  yearRange: string;
  categorylist: any = [];
  errorMessage = '';
  categoryName: any;
  categoryCode: any;
  id: any;
  categoryId: any;
  sponsorsId: any;
  @ViewChild('fileUploader') fileUploader!: FileUpload;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropDialog: boolean = false;
  selectedFile: File | null = null;
  existimageShow: boolean =true;
  imageSize = 2000000;
  croppedImageMaxSize = 2000000;
  croppedImageSize = 0;
  croppedImageError: string | null = null;
  scale = 1;
  transform: ImageTransform = {};
  cropApplied = false;
    deletedImages: any[] = [];

  constructor(private formBuilder: FormBuilder, private router: Router, private sponsorsService: SponsorsService, private messageService: MessageService,
    private categoryService: CategoryService, private confirmationService: ConfirmationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.yearRange = this.minYear + ":2030";
    this.pagetitle = 'Edit Sponsor';
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.id = params['id'];
      console.log(this.id,'xcvvv');
    })
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];

    this.sponsorsForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      category: ['', [Validators.required]],
      brandName: ['', [Validators.required]],
      status: [true, Validators.required],
      link: [''],     
    })
  
    this.getSubCategory();
    this.getSponsorsData(this.id);  

  }  
  
  getSubCategory(){              
      const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sponsors`;
            this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {                        
              this.categorylist = data.data.items;                   
      },
      err => {
          this.errorMessage = err.error.message;
      }
    );
  }
 

  getSponsorsData(id: string) {    
    this.sponsorsService.getSponsorsById(id).pipe(takeUntil(this.destroy$)).subscribe((data) => { 
      this.sponsorsId = data['_id'],
      this.categoryId = data['category'];  
      this.sponsorsForm.patchValue({
        title: data['title'],
        category: data['category'],  
        categoryId: data['category'],
        brandName: data['brandName'],        
        sponsorsImage: data['photo'],
        sponsorsId: data['_id'],
        status: data['status'],
        link: data['link'],
      });
  
      if (data['photo'] !== undefined && data['photo'] !== null) {
        this.sponsorsImage = data['photo'];
        this.previousSponsorsImageExists = true;
      } else {
        this.sponsorsImage = [];
        this.previousSponsorsImageExists = false;
      }
    });
  }


  onCategorySelect(event) {    
    if (event) {  
        this.categoryName = event.name;
        this.categoryCode = event._id;
    }
  }

  get f() {
    return this.sponsorsForm.controls;
  }

  onStatusSelect(event) {
    if (event) {
      this.sponsorsStatus = event.value;
    }
  }

  onFileSelect(event: any) {
    const file = event.files[0];
    if (!file) return;
    if (file.size > this.imageSize) {
      this.rejectOversizedImage();
      return;
    }
    this.cropApplied = false;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = file;
    this.resetZoom();
    const fileEvent: any = {
      target: {
        files: [file]
      }
    };
    this.imageChangedEvent = fileEvent;
    this.cropDialog = true;
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    if (this.scale > 0.2) {
      this.scale -= 0.1;
      this.transform = {
        ...this.transform,
        scale: this.scale
      };
    }
  }

  resetZoom() {
    this.scale = 1;
    this.transform = {
      ...this.transform,
      scale: 1
    };
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
    this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
      ? 'Cropped image size must be less than 2 MB.'
      : null;
  }
        
  getBase64SizeBytes(base64: string): number {
    if (!base64) return 0;
    return Math.round(
      (base64.length * (3 / 4)) -
      (base64.split(',')[0].length + 1)
    );
  }

  applyCrop() {
    if (this.croppedImageError) return;
    const file = this.base64ToFile(
      this.croppedImage,
      this.selectedFile?.name || 'image.png'
    );
    this.fileUploader.clear();
    if (file.size > this.croppedImageMaxSize) {
      this.croppedImageError = 'Cropped image size must be less than 2 MB.';
      return;
    }
    const event = {
      files: [file]
    };
    this.picUploader(event);
    this.fileUploader.files = [file];
    this.cropApplied = true;
    this.cropDialog = false;
    this.existimageShow=false;
  }

  onCropCancel() {
    this.cropApplied = false;
    this.cropDialog = false;
    this.imageChangedEvent = null;
    this.croppedImage = null;
    this.croppedImageError = null;
    this.croppedImageSize = 0;
    this.selectedFile = null;
    this.resetZoom();
    if (this.fileUploader) {
      this.fileUploader.clear();
    }
    this.uploadedFiles = [];
    this.sponsorsImageUpload = null;
  }

  onDialogHide() {
    if (!this.cropApplied) {
      this.onCropCancel();
    } else {
      this.imageChangedEvent = null;
      this.croppedImage = null;
      this.croppedImageError = null;
      this.croppedImageSize = 0;
      this.selectedFile = null;
      this.resetZoom();
    }
  }
        
  rejectOversizedImage() {
    this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 2 MB', life: 6000 });
    this.onCropCancel();
  }

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  picUploader(event) {
    const files: File[] = event?.files || event;
    if (!files || files.length === 0) return;
      for (let file of files) {
          this.uploadedFiles.push(file);
          var reader = new FileReader();
          reader.readAsDataURL(this.uploadedFiles[0]);
          reader.onload = () => {             
            this.sponsorsImageUpload =reader.result;
          }
      }
  }

  removeFile(event) {
    this.uploadedFiles = [];
    this.sponsorsImages = [];
  }

  // removeSponsorsImage(): void {
  //   this.confirmationService.confirm({
  //     message: 'Are you sure you want to delete this image ?',
  //     header: 'Confirm',
  //     icon: 'pi pi-exclamation-triangle',
  //     accept: () => {
  //       this.sponsorsImageUpload = null;
  //       this.previousSponsorsImageExists = false;
  //     },
  //     reject: () => {
  //       this.previousSponsorsImageExists = true;
  //     }
  //   });
  // }

 onSubmit() {
  this.submitted = true;

  let updateSponsorsData: any = {};

  // Image validation only for Add mode
  if (!this.sponsorsImageUpload && !this.sponsorsImage) {
    this.notproduct = true;
    return;
  }

  this.notproduct = false;

  if (this.sponsorsForm.invalid) {
    return;
  }

  updateSponsorsData['title'] = this.sponsorsForm.value.title;
  updateSponsorsData['category'] = this.sponsorsForm.value.category;
  updateSponsorsData['brandName'] = this.sponsorsForm.value.brandName;
  updateSponsorsData['status'] = this.sponsorsForm.value.status;
  updateSponsorsData['link'] = this.sponsorsForm.value.link;

  // Only new uploaded image
  if (
    this.sponsorsImageUpload &&
    typeof this.sponsorsImageUpload === 'string' &&
    this.sponsorsImageUpload.startsWith('data:image')
  ) {
    updateSponsorsData['photo'] = this.sponsorsImageUpload;
  }

  // Deleted image
  if (this.deletedImages?.length > 0) {
    updateSponsorsData['deleted_images'] = this.deletedImages;
  }

  const data = JSON.stringify(updateSponsorsData, null, 4);

  this.sponsorsService
    .updateSponsors(this.id, data)
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (data) => {
        this.messageService.add({
          key: 'toastmsg',
          severity: 'success',
          summary: 'Successful',
          detail: 'Sponsors updated Successfully',
          life: 6000
        });

        setTimeout(() => {
          this.router.navigate(['/manage/media/sponsors']);
        }, 2000);
      },
      (error) => {
        this.messageService.add({
          key: 'toastmsg',
          severity: 'error',
          summary: 'Error',
          detail: error.error.message,
          life: 6000
        });
      }
    );
}

  backLink() {
    this.router.navigate(['/manage/media/sponsors']);
  }


 onDelete(imageSrc: any): void {
  this.confirmationService.confirm({
    message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this image?
      </p>
    `,
    header: 'Confirm',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
    acceptIcon: '',
    rejectIcon: '',

    accept: () => {

      if (imageSrc && !this.deletedImages.includes(imageSrc)) {
        this.deletedImages.push(imageSrc);
      }

      // Remove image from UI
      this.sponsorsImage = null;
      this.sponsorsImageUpload = null;

      // Validation state
      this.previousSponsorsImageExists = false;
      this.sponsorsImages = [];
    },

    reject: () => {}
  });
}
  editSponsorImage() {
    this.fileUploader.choose();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
